/*
This list should be supported by SEO team.
This is a list of indexed SERP sites on HA platform.
 */
module.exports = {
    ABRITEL: 'abritel',
    VRBO: 'vrbo',
    HA_US: 'homeaway_us',
    HA_UK: 'homeaway_uk',
    HA_CA: 'homeaway_ca',
    HA_CAFR: 'homeaway_cafr',
    HA_AU: 'homeaway_au',
    HA_LK: 'homeaway_lk',
    HA_SG: 'homeaway_sg',
    // HA_JP: 'homeaway_jp', // not supported yet
    HA_ES: 'homeaway_es',
    HA_MX: 'homeaway_mx',
    HA_DE: 'homeaway_de',
    HA_AT: 'homeaway_at',
    HA_IT: 'homeaway_it',
    HA_PT: 'homeaway_pt',
    HA_BR: 'homeaway_br',
    HA_NL: 'homeaway_nl',
    HA_DK: 'homeaway_dk',
    HA_GR: 'homeaway_gr',
    HA_FI: 'homeaway_fi',
    HA_NO: 'homeaway_no',
    HA_PL: 'homeaway_pl',
    HA_SE: 'homeaway_se'
};
